/**
 * Unicode-safe base64 encoding function that properly handles non-ASCII characters.
 * This replaces the native btoa() function which fails with non-ASCII characters.
 *
 * @param str - The string to encode
 * @returns Base64 encoded string
 */
export function encodeBase64Unicode(str: string): string {
    // First encode the string as UTF-8, then convert to base64
    return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode(parseInt(p1, 16));
        })
    );
}

/**
 * Unicode-safe base64 decoding function that properly handles non-ASCII characters.
 * This replaces the native atob() function for strings that were encoded with encodeBase64Unicode.
 *
 * @param str - The base64 encoded string to decode
 * @returns Decoded string
 */
export function decodeBase64Unicode(str: string): string {
    // First decode from base64, then decode from UTF-8
    return decodeURIComponent(
        Array.prototype.map
            .call(atob(str), (c: string) => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );
}
